<script>
import {
  VueSpinner,
// ...
} from 'vue3-spinners';
import {CONSTANTS} from "@/helpers/constants";

export default {
  name: 'Metfone-Loading',
  components: {
    VueSpinner,
  },
  setup() {

  },
  data() {
    return {};
  },
  async created() {

  },
  computed: {},
  mounted() {
  },
  methods: {
    color_primary() {
      return CONSTANTS.color_primary
    },
  },
}

</script>

<template>
  <div class="loading-of-service">
    <div class="loading-service-content">
      <!--      <div class="sr-icon">-->
      <!--        <img src="@/static/eMoneyLogo-tron_3.svg" width="80" height="80" alt="" class="cs-img-icon">-->
      <!--      </div>-->
      <!--      <h3 class="sr-title" style="width: 50%; margin-top: 40px">-->
      <!--        <van-progress :percentage="percent" :show-pivot="false" color="#00bcd4" track-color="#C4C4C4" :stroke-width="8"/>-->
      <!--      </h3>-->
      <!--      <p class="sr-subTitle">  {{ $t("downloading")}} </p>-->
      <VueSpinner size="50" :color="color_primary()"/>
    </div>
  </div>

</template>

<style scoped lang="scss">
.loading-of-service {
  //padding: 24px 16px;
  //background-color: #EAECF0;
  min-height: 70vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  box-sizing: border-box;
}

//@media (max-width: 414px) {
//  .loading-of-service {
//    min-height: 100vh;
//  }
//
//}
//
//@media (min-height: 737px) {
//  .loading-of-service {
//    min-height: 100vh !important;
//  }
//
//}
//
//@media (min-height: 813px) {
//  .loading-of-service {
//    min-height: 100vh !important;
//  }
//
//}


.loading-service-content {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  width: 100%;
  /*padding: 6.25em 0;*/
  height: calc(100vh - 200px);
}

@media (max-width: 414px) {
  .service-content {
    padding: 4.9em 0;
  }
}

@media (max-width: 375px) {
  .service-content {
    padding: 2.8em 0;
  }
}


.service-content .sr-icon {
  width: 70px;
  height: 70px;
  border: 1px solid #fff;
  border-radius: 50%;
}

.loading-service-content .sr-title {
  color: #494949;
  text-align: center;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 32px;
  margin: 8px 0px;
}

.loading-service-content .sr-subTitle {
  color: #25272C;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px; /* 200% */
  margin-top: 4px;
}

.sr-description {
  color: #494949;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 21px */
  text-align: justify;
}

.aba-term-conditions {
  color: #005D85;
  text-decoration: underline;
}

</style>
